import { handleCookie } from '@utils';

import { TMiddleware } from '@modules/types';
import { userActions } from '@modules/user';

import { checkActionsType } from './utils';

const { setCookie } = handleCookie;

export const initBranch: TMiddleware = () => next => action => {
  if (checkActionsType(action, [userActions.initBranch])) {
    const referralCode = action.payload?.data?.data_parsed?.referral_code;
    if (referralCode) setCookie('referral_code', referralCode, { expires: 30 });
  }
  return next(action);
};

export default initBranch;
